import { setMessage } from 'redux/common/messageSlice';
import { ERROR_MESSAGES, SEVERITY_ERROR } from 'utils/constants';

export const errorHandler = (dispatch, error) => {
    const errMsg = {
        message: ERROR_MESSAGES[error?.response?.status] || error?.message,
        severity: SEVERITY_ERROR,
        status: error?.response?.status,
    };

    dispatch(setMessage(errMsg));
};

export const successHandler = (dispatch, message) => {
    dispatch(
        setMessage({
            message,
        }),
    );
};
